import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { StyleProp, TextStyle, TouchableOpacity, ViewStyle } from 'react-native'
import { colors } from 'infra/color'
import { BaseText } from 'ui/common/text'
import { RowLayout } from 'ui/common/layout'

const Touchable = styled(TouchableOpacity)`
  border-radius: 16px;
  background-color: ${colors.gray.v200};
  border: 1px solid ${colors.gray.v200};
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
`

const ButtonText = styled(BaseText)`
  font-weight: bold;
`

export const Button: React.FC<{
  title: string
  onPress: () => void
  buttonStyle?: StyleProp<ViewStyle>
  textStyle?: StyleProp<TextStyle>
  leftChildren?: ReactElement
}> = (props) => {
  return (
    <Touchable onPress={props.onPress} style={props.buttonStyle}>
      <RowLayout style={{ alignItems: 'center' }}>
        {props.leftChildren}
        <ButtonText style={props.textStyle}>{props.title}</ButtonText>
      </RowLayout>
    </Touchable>
  )
}
